<template>
  <div>
    <div
      :class="$vuetify.breakpoint.mobile ? 'flex-column mb-3' : 'justify-space-between'"
      class="d-flex"
    >
      <div
        class="titre-h3 mt-3 mb-3 ml-2"
      >
        Mes outils d'analyse
        <AgrButton
          class="margin-top"
          icon
          @click="isOpenModalHelp = true"
        >
          <v-icon color="primary">
            mdi-information
          </v-icon>
        </AgrButton>
        <v-chip
          v-if="isDisplayNouveaute"
          color="#DBBD00"
          label
          small
          class="texte"
        >
          <span class="white--text">Nouveau</span>
        </v-chip>
      </div>
      <PrevisionRebond
        :class="$vuetify.breakpoint.mobile ? '' :'position'"
      />
    </div>
    <div
      :class="[$vuetify.breakpoint.mobile ? 'flex-column' : 'justify-space-between ml-1 mb-3', !$vuetify.breakpoint.mobile && redirection ? 'mt-2' : '']"
      class="d-flex"
    >
      <div class="mt-3">
        <BaseSelectAnneeRecolte
          :annee-recolte-selected="anneeSelected"
          :code-graine-selected="codeGraineCulturialSelected"
          :liste-annees-recoltes="listeAnneesRecoltes"
          :liste-graines-a-afficher="grandesCulturesSorted"
          :loading="loading.anneeRecolte"
          @selectAnneeRecolte="selectRecolte"
          @selectGraine="selectGraine"
        />
      </div>
      <div
        :class="$vuetify.breakpoint.mobile ? 'w-100 my-3' : 'align-self-end'"
      >
        <AgrButton
          color="primary"
          block
          large
          :class="$vuetify.breakpoint.mobile ? '' : 'align-self-end'"
          @click.prevent="openModalGroupeComparaison"
        >
          <v-icon>mdi-account-multiple-outline</v-icon>
          <span class="action text-truncate white--text ml-1">Groupe de comparaison</span>
          <v-menu
            bottom
            content-class="elevation-0"
            open-on-hover
          >
            <template v-slot:activator="{ on, attrs, value }">
              <div v-on="on">
                <v-badge
                  v-if="!loading.grainesRs3 && !$vuetify.breakpoint.mobile"
                  floating
                  :offset-x="$vuetify.breakpoint.mobile ? '-65' : '-5'"
                  :offset-y="-10"
                  color="secondary"
                  :content="nbFiltresSelectionnes"
                />
              </div>
            </template>
            <div>
              <v-card
                class="mt-10 pa-3 mb-4"
                elevation="2"
              >
                <v-card-title class="intro secondary--text">
                  {{ nbFiltresSelectionnes }} filtre{{ nbFiltresSelectionnes > 1 ? 's' : '' }} séléctionné{{ nbFiltresSelectionnes > 1 ? 's' : '' }}
                </v-card-title>
                <FiltresComparaisonChips
                  :filtre="filtresAdherentModifiable"
                  @updateFiltre="updateFiltre"
                />
              </v-card>
            </div>
          </v-menu>
        </AgrButton>
      </div>
    </div>
    <div v-if="loading.grainesRs3">
      <BaseLoader />
    </div>
    <BaseCardV2
      v-if="!loading.grainesRs3 && grandesCulturesSorted?.length === 0"
      class="mt-5"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-10' "
        class="d-flex
        align-center
        flex-column pb-6"
      >
        <img
          alt="no-comparaison"
          src="@/assets/no-cultures.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class=" d-flex flex-column intro texte-gris-fonce  mt-2 text-justify mx-5"
        >
          <span class="text-center">Renseignez vos cultures de vente pour accéder aux outils d'analyse.
          </span>
        </div>
        <div class="mt-3">
          <AgrButton
            color="primary"
            block
            large
            :class="$vuetify.breakpoint.mobile ? '' : 'align-self-end'"
            @click.prevent="toPageCulture()"
          >
            <span class="action text-truncate white--text ml-1">Renseignez mes cultures</span>
          </AgrButton>
        </div>
      </div>
    </BaseCardV2>
    <TableauDeBordOutilsAnalyse
      :annee-selected="anneeSelected"
      :code-graine-selected="codeGraineCulturialSelected"
      :loading="loading"
      :cultures="grandesCulturesSorted"
      :synthese="synthese"
      :graines-selected="grainesRs3Selected"
      :has-regions="filtresAdherentModifiable?.regionsAgrial?.length > 0"
      :filtres="filtresAdherentModifiable"
    />
    <div
      v-if="!loading.grainesRs3 && hasGrandesCultures"
      class="d-flex justify-center pb-3"
    >
      <span class="asterix">* Evolution par rapport à l’année précédente
      </span>
    </div>

    <HelpModal
      v-if="isOpenModalHelp"
      titre="Mes outils d'analyse"
      :is-open-modal-help="isOpenModalHelp"
      @close="isOpenModalHelp = false"
    >
      <div slot="baseCardHelpContent">
        <div class="texte text-justify texte-gris-fonce pa-8">
          <p>Retrouvez ici une synthèse de vos analyses par culture d'assolement.</p>
          <p>Vos cultures doivent être renseignées pour bénéficier des fonctionnalités de cette page.</p>
        </div>
      </div>
    </HelpModal>
    <FiltreComparaisonModal
      v-if="isOpenModalFiltres"
      :is-open-modal-filtres="isOpenModalFiltres"
      @close="isOpenModalFiltres = false"
      @update="onUpdateFiltres"
    />
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="toCompte()"
    >
      <InfoManquanteContentModal />
    </InfoModal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {clone} from '@/utils/clone'
import { orderBy, remove } from 'lodash'
import { isBefore } from 'date-fns'
import { cancelAllRequests, refreshToken } from '@/utils/axios-helper'
import { AgrButton } from '@agrial/ui'
import BaseSelectAnneeRecolte from '@/components/common/base-select-annee-recolte.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import FiltreComparaisonModal from '@/views/groupe-comparaison/components/modal/filtre-comparaison-modal.vue'
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import PrevisionRebond from './components/prevision-rebond.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import InfoManquanteContentModal from '@/components/modal/info-manquante-content-modal.vue'
import FiltresComparaisonChips from './components/filtres-comparaison-chips.vue'
import TableauDeBordOutilsAnalyse from './components/tableau-de-bord-outils-analyse.vue'


export default {
  name: 'PageOutilsAnalyse',
  beforeRouteEnter (to, from, next) {
    next( vm => {
      if (from.name === 'main.mes-cultures' || from.name === 'main.faq'  || from.name === 'main.comparateur-marge-adherent') {
        vm.isFromPageSansGraineRs3 = true
      }
    })
  },
  components: {BaseLoader, AgrButton, PrevisionRebond, BaseSelectAnneeRecolte, BaseCardV2, HelpModal, FiltresComparaisonChips, FiltreComparaisonModal, InfoModal, InfoManquanteContentModal, TableauDeBordOutilsAnalyse},
  data () {
    return {
      isFromPageSansGraineRs3: false,
      pagePath: 'main.mes-outils-d-analyse',
      menu: false,
      loading: {
        grainesRs3: false,
        filtres: false,
        anneeRecolte: false,
        synthese: false
      },
      erreur: {
        grainesRs3: false,
        filtres: false,
        anneeRecolte: false,
        synthese: false
      },
      anneeSelected: null,
      codeGraineCulturialSelected: null,
      isOpenModalHelp: false,
      isOpenModalFiltres: false,
      isOpenModaleInfosManquantes: false,
      filtresAdherentModifiable: {},
    }
  },
  computed: {
    ...mapGetters({
      adherent: 'adherent/adherent',
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      grainesRs3:'application/grainesRs3',
      codeGraineActive: 'application/codeGraineActive',
      grainesContractualiseesEtRecoltees: 'graine/grainesContractualiseesEtRecoltees',
      listeAnneesRecoltes: 'recolte/listeAnneesRecoltes',
      abonnements: 'adherent/abonnements',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      redirection: 'redirection/redirection',
      cultures: 'culture/cultures',
      codeCultureDemandee: 'culture/codeCultureDemandee',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      synthese: 'syntheseAnalyse/syntheseAnalyse'
    }),
    dashboardKey () {
      return `${this.anneeSelected}-${this.codeGraineCulturialSelected}`
    },
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasGrandesCultures () {
      return this.grandesCulturesSorted && this.grandesCulturesSorted?.length > 0
    },
    grandesCulturesSorted () {
      return orderBy(this.cultures.filter(c => c.typeCulture.codeTypeCultureParent === 'GC' && c.surfaceEnHectare!= null), ['surfaceEnHectare'], ['desc']).map(c => {
        return { code: c.typeCulture.code, libelle: c.typeCulture.nom, surface: c.surfaceEnHectare }
      })
    },
    grainesRs3Selected () {
      if (
        !this.codeGraineCulturialSelected ||
        this.codeGraineCulturialSelected === 'Tous'
      ) {
        return null
      }

      const culture = this.cultures.find(
        c => c.typeCulture.code === this.codeGraineCulturialSelected
      )

      return culture?.typeCulture?.graineRs3Correspondantes?.length
        ? culture.typeCulture.graineRs3Correspondantes
        : null
    },
    isDisplayNouveaute () {
      const dateJour = new Date()
      const dateFinNouveaute = new Date(2026, 9, 31)
      return isBefore(dateJour, dateFinNouveaute)
    },
    nbFiltresSelectionnes () {
      return this.filtresAdherentModifiable!= null && this.filtresAdherentModifiable.regionsAgrial!= null ? this.filtresAdherentModifiable?.regionsAgrial?.length + Object.values(this.filtresAdherentModifiable).filter(f => f.code != null && f.code !== 'TOUS').length : 0
    }
  },

  created () {
    this.loading.grainesRs3 = true
    this.loading.anneeRecolte = true
    this.getRedirection(this.pagePath)
    const numtiersSelected = this.$cookies.get('NUMTIERS_SELECTED') || this.adherent.numtiers
    this.anneeSelected = this.anneeRecolteActive != null ? this.anneeRecolteActive : this.anneeRecolteEnCours
    this.loadVerrouillage()
    Promise.all([
      this.fetchAbonnements(),
      this.fetchAdherent(numtiersSelected),
      this.fetchRecoltesContractualiseesEtRecoltees(numtiersSelected),
      this.loadSynthese()
    ]).then(() => {
      this.loadFiltres()
    })
  },
  methods: {
    ...mapActions({
      fetchAdherent: 'adherent/fetchAdherent',
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      initFiltres: 'filtresComparaison/initFiltres',
      fetchAbonnements: 'adherent/fetchAbonnements',
      setFiltres: 'filtresComparaison/setFiltres',
      getRedirection: 'redirection/getRedirection',
      getCultures: 'culture/getCultures',
      getCulturesSansMouvement: 'culture/getCulturesSansMouvement',
      oublierCultureDemandee: 'culture/oublierCultureDemandee',
      getSynthese: 'syntheseAnalyse/getSyntheseAnalyse',
      getAtelierCultureVerrouillage:'cloture/getAtelierCultureVerrouillage'
    }),
    loadGrainesCulturial () {
      this.loading.grainesRs3 = true
      this.loading.anneeRecolte = true
      this.erreur.grainesRs3 = false

      return Promise.all([
        this.getCultures(this.anneeSelected),
        this.getCulturesSansMouvement(this.anneeSelected)
      ])
        .then(() => {
          this.findCodeGraineCulturialSelected()
        })
        .catch(() => {
          this.erreur.grainesRs3 = true
        })
        .finally(() => {
          this.loading.grainesRs3 = false
          this.loading.anneeRecolte = false
        })
    },
    loadFiltres () {
      this.loading.filtres = true
      this.erreur.filtres = false
      return this.initFiltres(this.adherent.codeRegion)
        .then(() => {
          this.filtresAdherentModifiable = clone(this.filtresAdherent)
          this.loadGrainesCulturial()
        })
        .catch(() => {
          this.erreur.filtres = true
        })
        .finally(() => {
          this.loading.filtres = false
        })
    },
    loadVerrouillage () {
      return this.getAtelierCultureVerrouillage().catch(() => {})
    },
    loadSynthese () {
      this.loading.synthese = true
      this.erreur.synthese = false
      return this.getSynthese()
        .catch(() => {
          this.erreur.synthese = true
        })
        .finally(() => {
          this.loading.synthese = false
        })
    },
    selectGraine (codeGraine) {
      if (codeGraine === this.codeGraineCulturialSelected) {
        return
      }

      cancelAllRequests()
      refreshToken()
      this.updateCodeGraineActive(codeGraine)
      this.codeGraineCulturialSelected = codeGraine
    },
    async selectRecolte (anneeRecolte) {
      this.loading.anneeRecolte = true

      try {
        this.updateAnneeRecolteActive(anneeRecolte)
        this.anneeSelected = anneeRecolte

        await Promise.all([
          this.loadGrainesCulturial(),
          this.loadSynthese(),
          this.loadVerrouillage()
        ])
      } finally {
        this.loading.anneeRecolte = false
      }
    },
    onUpdateFiltres () {
      this.filtresAdherentModifiable = clone(this.filtresAdherent)
      this.isOpenModalFiltres = false
    },
    updateFiltre (data) {
      this.filtresAdherentModifiable = clone(this.filtresAdherent)
      if (data.label === 'regionsAgrial') {
        this.filtresAdherentModifiable.regionsAgrial = remove(this.filtresAdherent.regionsAgrial, (r) => { return r.codeRegion !== data.value.codeRegion })
      } else {
        this.filtresAdherentModifiable[data.label] = { code: data.value, libelle: 'Tous' }
      }
      this.updateFiltresAdherent()
    },
    updateFiltresAdherent () {
      return this.setFiltres(this.filtresAdherentModifiable)
        .catch(() => this.erreur.filtres = true)
    },
    findCodeGraineCulturialSelected () {
      let typeCultures = this.cultures.filter(c => c.typeCulture.codeTypeCultureParent === 'GC').map(c => c.typeCulture)

      const cultureDemandee = this.codeCultureDemandee
      if (cultureDemandee != null) {
        this.oublierCultureDemandee()
      }
      if (cultureDemandee != null && typeCultures.some(typeCulture => typeCulture.code === cultureDemandee)) {
        this.codeGraineCulturialSelected = cultureDemandee
        return
      }

      if (!this.isFromPageSansGraineRs3) {
        this.codeGraineCulturialSelected = null
        typeCultures.forEach(typeCulture => {
          if (typeCulture.code === this.codeGraineActive) {
            this.codeGraineCulturialSelected = typeCulture.code
          }
          if (typeCulture.graineRs3Correspondantes.length) {
            typeCulture.graineRs3Correspondantes.forEach(graineRs3 => {
              if (graineRs3.code === this.codeGraineActive) {
                this.codeGraineCulturialSelected = typeCulture.code
              }
            })
          }
        })
        this.codeGraineCulturialSelected = this.codeGraineCulturialSelected ? this.codeGraineCulturialSelected : 'Tous'
      } else {
        this.codeGraineCulturialSelected = 'Tous'
      }
    },
    openModalGroupeComparaison () {
      if (this.isParametresExploitationComplet) {
        this.isOpenModalFiltres = true
      } else {
        this.isOpenModaleInfosManquantes = true
      }
    },
    toCompte () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.compte' })
    },
    toPageCulture () {
      this.$router.push({ name: 'main.mes-cultures' })
    },
  }
  
}
</script>
<style lang="scss" scoped>
.asterix {
  font-size: 0.875rem;
  color: var(--gris-fonce);
}
.position {
  position: absolute;
  top: 0;
  right: 20px;
}
.teste {
  transition:all 0.2s ease-in-out; 
}
</style>
